"use strict";

/**
* Предоставляет работу с деревом папок.
*
* @namespace WebAccess.components.wrappers.folderTree.FolderTree
* @property {string} containerSelector Блок, содержащий дерево папок
* @fires WebAccess.current.objectList#onChange Вызывается после изменения дерева папок.
* @since 5.2.0.1600
*/

(function (global) {

  var FolderTree = BaseObject.extend({
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    className: 'FolderTree',
    containerSelector: '#tree_container',

    _data: [],
    _containerId: {},
    _promise: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function (promise) {      
      this._super();
      this._promise = promise;
    },

    /**
     * Инициализирует объектную модель для react-компоненты.
     * @param {string} containerId ID контейнера
     * @param {Array} state Модель дерева.
     */
    initComponent: function (containerId, state) {      
      this._data = state;
      this._containerId = containerId;
      this.containerSelector = '#' + containerId;

      if (this._promise) this._promise.resolve();
    },

    /**
     * Установить произвольное содержимое вместо текущего списка объектов.
     *
     * @method WebAccess.components.wrappers.folderTree.FolderTree.setHtml
     * @return {WebAccess.components.wrappers.folderTree.FolderTree} Объект типа folderTree.
     */
    setHtml: function (html) {
      $(this.containerSelector).html(html);
      return this;
    },

    /**
     * Выполнить переход в указанную папку.
     *
     * @param {object} [nodeInfo] Элемент дерева.
     */
    selectNode(nodeInfo = false) {
      // Если не указан nodeInfo, передаём обрабтку события дальше.
      if (!nodeInfo) {
        return false;
      }

      const gridWidths = JSON.parse(localStorage.getItem(window.FOLDER_GRID.WIDTHS_STORAGE_KEY) || "{}");
      const folderOptions = gridWidths[nodeInfo.id] || {};
      nodeInfo.folderMode = folderOptions[window.FOLDER_GRID.FOLDER_MODE_KEY] ||
        (nodeInfo.hasFolderCover ? window.FOLDER_MODE.COVER : window.FOLDER_MODE.NONE);

      const url = this._buildFolderUrl(nodeInfo);
      const prevPath = window.GetParamInURL('fpath');
      const nextPath = nodeInfo.key;

      // Записать в историю переход.
      let state = {
        type: 'explorer',
        folderID: nodeInfo.id,
        path: nodeInfo.key,
        title: nodeInfo.caption,
        folderMode: nodeInfo.folderMode,
        hasCoverOnly: nodeInfo.showCoverOnly,
        contentType: nodeInfo.contentType
      };
      WA.history.pushState(state, nodeInfo.caption, url);

      this.markAsSelected(nodeInfo);

      // Раскроем список. По информации найдем реальный узел, т.к. в инфо-объекте нет ссылок на потомков.
      let node = this._findNode(this._data, (n) => {
        return (n.key === nodeInfo.key);
      });
      if (node.children && node.children.length) {
        if (prevPath !== nextPath) {
          // Если до этого находились в другом узле, то выбранный всегда только раскрываем.
          this.openNode({ key: node.key });
        } else {
          this.toggleNode({ key: node.key });
        }
      } else {
        this.loadNode({ key: node.key }, () => {
          this.openNode({ key: node.key });
        });
      }
      // Отметим узел как выбранный и перерисуем дерево.
      this._render(this._data);

      return true;
    },

    /**
     * Отмечает узел в модели как выбранный.
     * @param {object} node Узел дерева.
     */
    markAsSelected: function (node) {
      var me = this;
      me._mapNodes(me._data, function (n) {
        n.selected = (n.key === node.key);
        return n;
      });

      return me;
    },

    /**
     * Открыть папку по fpath.
     *
     * @param {str} fpath Путь к папке.
     * @param {boolean} triggerClick Необходимость вызвать событие клика.
     */
    selectNodeByPath: function (fpath, triggerClick) {
      var me = this;
      var node = me._findNode(me._data, function (n) { return n.key === fpath });
      if (!node) {
        // Проверим, что папка является следующей по fpath. Если да, то загрузим узел и раскроем его.
        var currentPath = GetParamInURL('fpath');
        var prevPath = fpath.substring(fpath.indexOf('-') + 1, fpath.length);
        if (prevPath === currentPath && me._findNode(me._data, function (n) { return n.key === currentPath }) !== null) {
          me.loadNode({ key: currentPath }, function () {
            me.toggleNode({ key: currentPath });
            me.selectNodeByPath(fpath, triggerClick);
          });
          return true;
        }
        return false;
      }

      if (triggerClick) {
        me.selectNode(node);
      } else {
        // Отметим узел как выбранный и перерисуем дерево.
        me.markAsSelected(node)
          ._render(me._data);
      };
      return true;
    },

    /**
     * Обновить счетчик непрочитанных.
     *
     * @param {integer} folderID ИД папки.
     */
    updateUnreadJobCount: function (folderID, forceUpdateCache) {
      var me = this;

      var nodes = me._findNodes(me._data, function (n) {
        return n.id == folderID && n.showUnread;
      });

      if (nodes.length > 0) {
        WA.SRV.call('/Folder.asmx/GetUnreadJobCount', { 'FolderID': folderID }).done(function (count) {
          $.each(nodes, function (i, node) {
            node.unreadCount = count;
          });

          me._render(me._data);
          document.title = nodes[0].caption + (count > 0 ? ' (' + count + ')' : '');
        });
      }
    },

    /**
     * Обновляет узел дерева.
     *
     * @method WebAccess.components.wrappers.folderTree.FolderTree.updateNode
     * @param {} folderPath Путь к папке.
     * @param {} callback Callback-функция.
     */
    _updateNode: function (folderPath, callback) {
      var me = this;
      callback = callback || $.noop;

      var node = me._findNode(me._data, function (n) { return n.key === folderPath; });

      me.loadNode(node, function () {
        me._render(me._data);
        callback();
      });
    },

    /**
     * Обновляет все дерево целиком.
     *
     * @method WebAccess.components.wrappers.folderTree.FolderTree.update
     * @param {function} callback Callback-функция.
     */
    update: function (callback) {
      var me = this;
      var id = WA.CR.getID();
      var fpath = GetParamInURL('fpath');

      me.loadNode({ id: id, key: fpath }, function () {
        me._render(me._data);
        HideSpinner();
        if (callback) callback();
      });
    },

    /**
     * Обновить узел для указанной папки.
     *
     * @param {int} folderID ИД папки.
     * @param {function} callback Callback-функция.
     */
    updateByFolderID: function (folderID, callback) {
      var me = this;

      var nodes = me._findNodes(me._data, function (n) {
        return n.id == folderID;
      });

      if (nodes && nodes.length > 0) {
        me._getNodeContent(nodes[0]).done(function (children) {
          nodes.forEach(function (node) {
            node.children = JSON.parse(children);
            node.hasChildren = !!node.children.length;
          });

          me._render(me._data);
          if (callback) callback();
        });
      }
    },

    /**
     * Обновляет узлы, содержащие папку. Может принимать отдельные ID, массив с ID.
     * Если ничего не передано, обновляет узел, содержащий открытую папку.
     *
     * @method WebAccess.components.wrappers.folderTree.FolderTree.updateNodesWithFolder
     * @param folder ID папок.
     * @param callback Callback-функция.
     */
    updateNodesWithFolder: function (folderID, callback) {
      var me = this;
      var nodes = me._findNodesWithFolder(me._data, folderID);
      if (nodes.length > 0) {
        nodes.forEach(function (node) {
          me.updateByFolderID(node.id, callback);
        });
      } else {
        me.update();
      }
    },

    /**
     * Получить имя выбранной папки.
     *
     * @method WebAccess.components.wrappers.folderTree.FolderTree.getCurrentFolderName
     * @returns {string} Имя выбранной папки.
     */
    getCurrentFolderName: function () {
      var node = this._findNode(this._data, function (n) { return n.selected; });
      return node && node.caption;
    },

    /**
     * Установить отображаемое имя для папки.
     *
     * @method WebAccess.components.wrappers.folderTree.FolderTree.setFolderVisibleName
     * @param {int} id ИД папки.
     * @param {string} name Новое имя папки.
     */
    setFolderVisibleName: function (id, name) {
      var me = this;
      me._mapNodes(me._data, function (n) {
        if (n.id === id) {
          n.caption = name;
        }
        return n;
      });
      me._render(me._data);
    },

    /**
     * Обновить имя папки значением с сервера.
     *
     * @method WebAccess.components.wrappers.folderTree.FolderTree.updateFolderName
     * @param {int} id ИД папки.
     */
    updateFolderName: function (id) {
      var me = this;
      var nodes = me._findNodes(me._data, function (n) {
        return n.id == id;
      });

      if (nodes && nodes.length > 0) {
        WA.SRV.call('/Folder.asmx/GetName', { FolderID: id }).done(function (name) {
          nodes.forEach(function (node) {
            node.caption = name;
          });
          me._render(me._data);
        });
      }
    },

    /**************************************************************************************/
    /**
    * Возвращает массив узлов, содержащий путь к узлу с указанным ключом.
    * @param {string} key  Ключ.
    * @param {Array} nodes  Массив узлов.
    */
    _findNodePath: function (nodes, predicate) {
      for (var i = 0; i < nodes.length; i++) {
        if (predicate(nodes[i])) {
          return [nodes[i]];
        } else {
          if (nodes[i].children && nodes[i].children.length > 0) {
            var nodesPath = this._findNodePath(nodes[i].children, predicate);
            if (nodesPath && nodesPath.length > 0) {
              nodesPath.push(nodes[i]);
              return nodesPath;
            }
          }
        }
      }
      return null;
    },

    /**
    * Ищет узел дерева с указанным ключом.
    * @param {Array} nodes  Массив узлов.
    */
    _findNode: function (nodes, predicate) {
      var result = this._findNodes(nodes, predicate);
      return (result && result.length > 0) ? result[0] : null;
    },

    /**
    * Ищет узел дерева с указанным ключом.
    * @param {Array} nodes  Массив узлов.
    */
    _findNodes: function (nodes, predicate) {
      var result = [];
      for (var i = 0; i < nodes.length; i++) {
        if (predicate(nodes[i])) {
          result.push(nodes[i]);
        } else {
          if (nodes[i].children && nodes[i].children.length > 0) {
            var childNodes = this._findNodePath(nodes[i].children, predicate);
            if (childNodes && childNodes.length > 0) {
              result = result.concat(childNodes[0]);
            }
          }
        }
      }
      return result;
    },

    /**
     * Возвращает массив узлов, содержащих указанную папку.
     *
     * @param {Array} nodes Массив узлов.
     * @param {number} folderID ИД папки.
     * @returns {Array} Массив узлов с указанной папкой.
     */
    _findNodesWithFolder: function (nodes, folderID) {        
      var me = this;
      var result = [];
      nodes.forEach(function (item) {
        if (item.children && item.children.length > 0) {
          var filteredNodes = item.children.filter(function (n) { return n.id == folderID; });
          if (filteredNodes.length > 0) {
            result.push(item);
          };

          var childNodes = me._findNodesWithFolder(item.children, folderID);
          if (childNodes.length > 0) {
            childNodes.forEach(function (n) {
              if (!result.some(function (el) { return el.id === n.id })) {
                result.push(n);
              }
            });
          }
        }
      });
      return result;
    },

    /**
     * Преобразовывает указанные узлы.
     * @param {} nodes
     * @param {} changeFunc
     * @returns {}
     */
    _mapNodes: function (nodes, changeFunc) {
      for (var i = 0; i < nodes.length; i++) {
        nodes[i] = changeFunc(nodes[i]);
        if (nodes[i].children && nodes[i].children.length > 0) {
          this._mapNodes(nodes[i].children, changeFunc);
        }
      }

      return nodes;
    },

    /**
     * Инициирует перерисовку дерева.
     * @param {} state
     * @returns {}
     */
    _render: function (state) {
      ReactDOM.render(
        React.createElement(Component.FolderTree, { data: state, constants: { systemCode: g_SysCode, extension: g_ExtName } }),
        document.getElementById(this._containerId));
    },

    /**
     * Загружает содержимое узла.
     * @param {object} nodeInfo Информация об узле.
     * @param {function} onSuccess Callback при успешной загрузке.
     * @param {function} onFail Callback при ошибке.
     */
    loadNode: function (nodeInfo, onSuccess, onFail) {
      var me = this;
      if (me._data) {
        var node = me._findNode(me._data, function (n) {
          return n.key === nodeInfo.key;
        });

        if (node) {
          me._getNodeContent(node).done(function (res) {
            if (res) {
              var children = JSON.parse(res);
              node.hasChildren = (children.length > 0);
              node.children = children;

              if (onSuccess) onSuccess();
              if (!node.hasChildren) me._render(me._data);
            }
          }).fail(function (err) {
            log.error('FOLDER_TREE', err);
            if (onFail) onFail(err);
          });
        }

      }
    },

    /**
     * Выполняет запрос к сервису для загрузки содержимого узла.
     * @param {object} node Узел.
     * @returns {$.Deferred} Deferred-объект загрузки.
     */
    _getNodeContent: function (node) {
      var selectedNode = this._findNode(this._data, function (n) { return n.selected; });
      return WA.SRV.call('/FolderList.asmx/LoadTree', {
        FolderID: node.id,
        FolderPath: node.key,
        SelectedTreeItem: selectedNode ? selectedNode.key : ''
      });
    },

    /**
     * Раскрывает или сворачивает узел.
     * @param {object} node Информация об узле.
     */
    toggleNode: function (node) {
      this._mapNodes(this._data, function (n) {
        if (n.key === node.key) {
          n.expanded = !n.expanded;
          WA.SRV.call('/FolderList.asmx/SaveOpened', {
            IsOpening: n.expanded,
            FolderPath: node.key
          }, null, null, true, true); // не показываем ошибки
        } else if (node.key.indexOf(n.key) !== -1) {
          n.expanded = true; //раскрываем родителя
        }
        return n;
      });
      this._render(this._data);
    },

    /**
     * Всегда раскрывает узел
     * @param {object} node Информация об узле.
     */
    openNode: function (node) {
      this._mapNodes(this._data, function (n) {
        if (n.key === node.key) {
          n.expanded = true;
          WA.SRV.call('/FolderList.asmx/SaveOpened', {
            IsOpening: n.expanded,
            FolderPath: node.key
          }, null, null, true, true); // не показываем ошибки
        } else if (node.key.indexOf(n.key) !== -1) {
          n.expanded = true; //раскрываем родителя
        }
        return n;
      });
      this._render(this._data);
    },

    /**
     * Строит url для папки.
     * @private
     * @param {object} node Информация об узле.
     * @returns {string} Строка URL.
     */
    _buildFolderUrl(node) {
      let url = new WA.URL('Explorer.aspx');
      url
        .setParam('sys', g_SysCode)
        .setParam('ext', g_ExtName)
        .setParam('id', node.id);

      if (node.key) {
        url.setParam('fpath', node.key);
      }
      if (node.treeitem) {
        url.setParam('treeitem', node.treeitem);
      }
      if (node.folderMode) {
        url.setParam(window.FOLDER_GRID.FOLDER_MODE_URL_PARAM, node.folderMode);
      }

      return url.asString();
    }

  });

  global.components.wrappers.folderTree.FolderTree = FolderTree;

})(window.WebAccess);
